export default __webpack_public_path__ + "static/media/sence-1.4f77cb94.png";